import { CoreBox, CoreTypography } from '@youscience/core';

import { Major, searchFilters } from '@common-types';

import useSchoolSearchFiltersStore from '@store/SchoolSearchFiltersStore';
import useMajorSearchStore from '@store/MajorSearchStore';
import useHomePageStore from '@store/HomePageStore';
import { ROUTES } from '@constants/ROUTES';
import { getMajorIconSrc } from '@utils/major';

import { sxStyles, StyledAreaOfStudyCard, StyledAreaIcon } from './AreaOfStudyCard.styles';

export interface AreaOfStudyCardProps {
  currentCipCode: number;
  cipTitle: string;
  majors?: Major[];
}

export const AreaOfStudyCard = (props: AreaOfStudyCardProps) => {
  const { currentCipCode, cipTitle, majors = [] } = props;

  const landingPageSchoolData = useHomePageStore((state) => state.landingPageSchoolData);

  const { resetSearchFilters, getSchools } = useSchoolSearchFiltersStore((state) => state);

  const setSearchMajorsFilters = useMajorSearchStore((state) => state.setSearchFilters);

  const isLandingPage = !!landingPageSchoolData?.id;
  const navigateRoute = isLandingPage ? ROUTES.MAJORS : ROUTES.SCHOOLS;
  const areaIconSrc = getMajorIconSrc(currentCipCode);

  const suggestedCollegesCount = majors?.find((major) => {
    if (+major.cipCode === currentCipCode) {
      return major.collegesCount;
    }

    return '';
  });

  const handleSetSearchFilter = () => {
    const filters = {
      [searchFilters.areasOfStudy.fieldName]: [currentCipCode.toString()],
    };

    if (isLandingPage) {
      setSearchMajorsFilters(filters);
      return;
    }

    resetSearchFilters(filters);

    void getSchools();
  };

  return (
    <StyledAreaOfStudyCard data-testid="areaOfStudyCard" to={navigateRoute} onClick={handleSetSearchFilter}>
      <CoreBox>
        <StyledAreaIcon imageSrc={areaIconSrc} />
        <CoreTypography sx={sxStyles.title} variant="subtitle2">
          {cipTitle}
        </CoreTypography>
      </CoreBox>

      {!isLandingPage && (
        <CoreTypography sx={sxStyles.suggest}>
          {suggestedCollegesCount?.collegesCount && `${suggestedCollegesCount?.collegesCount} suggested colleges`}
        </CoreTypography>
      )}
    </StyledAreaOfStudyCard>
  );
};
